<template>
    <div class="pay-in__billing-details mt-3">
        <div class="font-weight-600 mb-3">Billing details</div>

        <!-- Read-only display -->
        <div v-if="readOnly" class="pay-in__billing-display">
            <div>
                <label>Billing name</label>
                <div class="pay-in__billing-value">{{ billingDetails.businessName || '-' }}</div>
            </div>
            <div>
                <label>VAT Number</label>
                <div class="pay-in__billing-value">{{ billingDetails.vat || '-' }}</div>
            </div>
            <div>
                <label>Address</label>
                <div class="pay-in__billing-value">{{ billingDetails.address || '-' }}</div>
            </div>
            <div>
                <label>City</label>
                <div class="pay-in__billing-value">{{ billingDetails.city || '-' }}</div>
            </div>
            <div>
                <label>Postal Code</label>
                <div class="pay-in__billing-value">{{ billingDetails.postalCode || '-' }}</div>
            </div>
            <div>
                <label>Country</label>
                <div class="pay-in__billing-value">{{ getCountryName(billingDetails.country) || '-' }}</div>
            </div>
        </div>

        <!-- Editable form -->
        <div v-else class="pay-in__billing-grid">
            <div>
                <label>VAT Number <span class="pay-in__required">*</span></label>
                <input type="text" class="full" v-model="billingDetails.vat" />
            </div>
            <div>
                <label>City</label>
                <input type="text" class="full" v-model="billingDetails.city" />
            </div>
            <div>
                <label>Postal Code</label>
                <input type="text" class="full" v-model="billingDetails.postalCode" />
            </div>
            <div>
                <label>Country <span class="pay-in__required">*</span></label>
                <country-picker
                    placeholder="Select Country"
                    :selectedCountryValue="billingDetails.selectedCountry"
                    :allowEmpty="false"
                    openDirection="bottom"
                    @input="onCountryChange"
                />
            </div>
            <div class="pay-in__billing-grid--span2">
                <label>Billing name</label>
                <input type="text" class="full" v-model="billingDetails.businessName" />
            </div>
            <div class="pay-in__billing-grid--span2">
                <label>Address</label>
                <input type="text" class="full" v-model="billingDetails.address" />
            </div>
        </div>
        <div v-if="!readOnly" class="text-right mt-2">
            <button class="btn tertiary" @click="autoFill">Auto Fill</button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CountryPicker from '@/tools/CountryPicker'

export default {
    components: { CountryPicker },
    props: {
        billingDetails: {
            type: Object,
            required: true,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['getSelectedReservation', 'getReservation', 'getReservationCreation', 'getCountries']),
    },
    methods: {
        onCountryChange(country) {
            this.billingDetails.selectedCountry = country
            this.billingDetails.country = country ? country.id : null
        },
        autoFill() {
            const reservation = this.getReservationCreation ? this.getReservation : this.getSelectedReservation
            const customer = (reservation && reservation.customer) || {}
            const details = (!this.getReservationCreation && reservation && reservation.billing && reservation.billing.details) || {}
            const customerName = [customer.name, customer.surname].filter(Boolean).join(' ')
            const countryId = details.country || customer.country || null

            Object.assign(this.billingDetails, {
                vat: details.vat || '',
                businessName: details.businessName || customerName || '',
                address: details.address || '',
                city: details.city || '',
                postalCode: details.postalCode || '',
                selectedCountry: this.getCountries.find(country => country.id === countryId) || null,
                country: countryId,
            })
        },
        getCountryName(countryId) {
            if (!countryId) return ''
            const country = this.getCountries.find(c => c.id === countryId)
            return country ? country.name : ''
        }
    },
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .pay-in__required {
        color: red;
    }

    .pay-in__billing-details {
        padding-right: 0;

        label {
            display: block;
            margin-bottom: 0.25rem;
        }
    }

    input:disabled {
        background-color: $lighter;
    }

    .pay-in__billing-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 0.75rem;

        &--span2 {
            grid-column: span 2;
        }
    }

    .pay-in__billing-display {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.5rem 1rem;

        label {
            display: block;
            margin-bottom: 0.1rem;
            color: $dark;
            font-size: $font-size-small;
        }
    }

    .pay-in__billing-value {
        color: $darkest;
        font-weight: 600;
    }
</style>



// WEBPACK FOOTER //
// BillingDetailsForm.vue?89a5a23c